import ajaxArchives from './features/ajaxArchives';
import ajaxForms from './features/ajaxForms';
import animations from './features/animations';
import archiveFilters from './features/archiveFilters';
import clipboard from './features/clipboard';
import contactForm from './features/contactForm';
import fileDownloads from './features/fileDownloads';
import googleMaps from './features/googleMaps';
import modals from './features/modals';
import navigation from './features/navigation';
import siteSearch from './features/siteSearch';
import sliders from './features/sliders';
import toaster from './features/toaster';
import videos from './features/videos';

$(function() {
	ajaxArchives();
	ajaxForms();
	animations();
	archiveFilters();
	clipboard();
	contactForm();
	fileDownloads();
	googleMaps();
	modals();
	navigation();
	siteSearch();
	sliders();
	toaster();
	videos();
});